export const PUSH_TOKEN = 'push-token';
export const PUSH_PERMISSION_REQUEST = 'push-permission-request';
export const PUSH_PERMISSION_STATE = 'push-permission-state';
export const usingAppleWebview = () => Boolean(window.webkit?.messageHandlers);
export function requestPushPermissionState() {
  window.webkit?.messageHandlers[PUSH_PERMISSION_STATE]?.postMessage(PUSH_PERMISSION_STATE);
}
export function requestPushPermissions() {
  window.webkit?.messageHandlers[PUSH_PERMISSION_REQUEST]?.postMessage(PUSH_PERMISSION_REQUEST);
}
export function requestPushToken() {
  window.webkit?.messageHandlers[PUSH_TOKEN]?.postMessage(PUSH_TOKEN);
}
flarum.reg.add('fof-pwa', 'forum/native/appleWebView', { PUSH_TOKEN: PUSH_TOKEN,PUSH_PERMISSION_REQUEST: PUSH_PERMISSION_REQUEST,PUSH_PERMISSION_STATE: PUSH_PERMISSION_STATE,usingAppleWebview: usingAppleWebview,requestPushPermissionState: requestPushPermissionState,requestPushPermissions: requestPushPermissions,requestPushToken: requestPushToken, });